export default __webpack_public_path__ + "static/media/waiting-for-approval.8078d6e7.svg";